import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Alert,
  Button,
  CircularProgress,
} from "@material-ui/core";
import Page from "src/components/Page";
import Page404 from "src/pages/Page404";
import { propuestasApi } from "src/services/propuestasApi";
import EditarPropuestaV2Container from "src/components/propuesta/EditarPropuestaV2";

export default function EditarPropuestaV2() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: propuesta, isLoading } = propuestasApi.useGetPropuestaV2Query({
    id,
  });

  if (isLoading) {
    return (
      <Page title="Cargando...">
        <Container maxWidth="xl" sx={{ py: 6 }}>
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        </Container>
      </Page>
    );
  }

  if (!propuesta) return <Page404 />;

  if (propuesta.estado !== "BORRADOR") {
    const enRenegociacion = propuesta.estado === "EN_RENEGOCIACION";
    return (
      <Page title="Edición no disponible">
        <Container maxWidth="md" sx={{ py: 4 }}>
          <Alert
            severity="warning"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => navigate(`/dashboard/propuestas/v2/${id}`)}
              >
                Volver al detalle
              </Button>
            }
          >
            {enRenegociacion ? (
              <>
                Esta propuesta está en negociación con el cliente. Los ajustes
                durante la conversación se gestionan desde la vista de la
                propuesta, no desde este editor de borrador.
              </>
            ) : (
              <>
                Solo las propuestas V2 en estado <strong>BORRADOR</strong> se
                pueden editar. Esta propuesta está en estado{" "}
                <strong>{propuesta.estado}</strong>.
              </>
            )}
          </Alert>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={`Editar propuesta #${id} — TAXTIC`}>
      <EditarPropuestaV2Container propuesta={propuesta} />
    </Page>
  );
}
